import { OutreachGroupKeySchema } from "@redotech/redo-model/aggregated-metrics/outreach";
import { outreachAnalyticsSchema } from "@redotech/redo-model/campaigns/campaign-definition";
import * as z from "zod/v4";

export const getOutreachAnalytics = {
  name: "getOutreachAnalytics" as const,
  input: z.object({ groupBy: OutreachGroupKeySchema }),
  output: outreachAnalyticsSchema,
};
